export default __webpack_public_path__ + "static/media/start.09ada121.png";